<template>
  <div class="flex-y-center justify-center h-full w-full max-w-[520px]">
    <Transition :name="transitionName" mode="out-in">
      <div :key="step">
        <CForgetPEmail
          v-if="step === 1"
          v-bind="{ form }"
          @submit="step = 2"
          @back="router.push({ path: '/auth/login' })"
          @on-block="step = 4"
        />
        <SStepResetPasswordConfirm
          v-if="step === 2"
          v-bind="{ phone, email: form.values.email, time }"
          @back="step = 1"
          @on-resend="resendCode"
          @submit="step = 3"
          @on-block="step = 4"
        />
        <CForgetRecovery
          v-if="step === 3"
          v-bind="{ email: form.values.email }"
          @back="step = 1"
          @submit="router.push({ path: '/auth/login' })"
        />
        <SStepBlocked v-if="step === 4" />
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { useForm } from "@/composables/useForm";
import { email, required } from "@vuelidate/validators";
import { useRouter } from "vue-router";
import { ref, watch, onMounted } from "vue";
import SStepBlocked from "@/modules/Auth/components/SStepBlocked.vue";
import { useAuthStore } from "@/modules/Auth/stores";
import CForgetPEmail from "@/modules/Auth/components/CForgetPEmail.vue";
import CForgetRecovery from "@/modules/Auth/components/CForgetRecovery.vue";
import SStepResetPasswordConfirm from "@/modules/Auth/components/SStepResetPasswordConfirm.vue";

import { usePushToDataLayer } from "@/composables/usePushToDataLayer";
const { pushToDataLayer } = usePushToDataLayer();

const store = useAuthStore();
const router = useRouter();

const phone = ref("");

const step = ref(1);
const time = ref(0);

const form = useForm(
  {
    email: "",
    password: "",
  },
  {
    email: {
      required,
      email,
    },
    password: {
      required,
    },
  },
);
async function resendCode() {
  await store.verifyOtpRecovery(form.values.email?.toLowerCase());
}

const transitionName = ref("slide-right");
watch(
  () => step.value,
  (newValue, oldValue) => {
    if (newValue < oldValue) {
      transitionName.value = "slide-left";
    } else {
      transitionName.value = "slide-right";
    }
  },
);
onMounted(() => {
  pushToDataLayer("pageview", {
    page: "reset_password",
    event_category: "page",
    event_label: "reset_password_page_view",
    button_text: "None",
  });
});
</script>
